
import { useEffect, useState } from 'react';
import { LiveChatWidget, useWidgetCustomerData, useWidgetIsReady } from "@livechat/widget-react";
import { DotLoading } from 'antd-mobile'
import { useParams } from "react-router-dom"
import "./index.css"
import { useTranslation } from 'react-i18next';
function Home() {
  const { t } = useTranslation()
  const customerData = useWidgetCustomerData();
  const isWidgetReady = useWidgetIsReady();
  const search = new URLSearchParams(window.location.search)
  // const call = LiveChatWidget();
  const [kfName, setName] = useState('')
  const [gameName, setgName] = useState('')
  let params = useParams()
  let id = params.id
  const [mail, setMail] = useState()

  let language = search.get('la')
  if(language)language = language?.replace(new RegExp('/', 'g'), '')
  if(language == 'vn') language = 'vi'
  if (!language) language = 'hk'

  let arr = ['vi', 'en', 'hk']
    let lang = 'en'
    for (var i = 0; i < arr.length; i++) {
      if (language == arr[i]) lang = arr[i]
    }

  const getName = () => {

    let gName = '未知'
    //11CztPJUU0JUI4JTg5JUU1JTlCJUJEJUU2JTg4JTk4JUU1JUE3JUFDbmKRM9
    if (id && id.length > 0) {
      let base = id.substring(6, id.length - 6)
      if (base && base.length > 0) {
        let name = decodeURIComponent(window.atob(base))
        console.log('nnnnn', name)
        if (name) gName = name
      }
    }
    if (gName == '未知') {
      let host = document.domain
      let urls = {
        'kf.crcq.cc': '成人傳奇',
        'kf.crsgz.cc': '成人三國志',
        'kf.cysj.vip': '次元世界',
        'kf.llzh.cc': '蘿莉召喚',
        'kf.mjdz.cc': '萌姬大戰',
        'kf.mjsn.cc': '冥界聖女',
        'kf.shzu.vip': '失足聖女',
        'kf.52lion.cn': '聖女連結',
        'kf.spmm.vip': '審判魅魔',
        'kf.sqbb.cc': '石器寶貝',
        'kf.taom.cc': '蜜桃連團',
        'kf.tjsg.cc': '調教三國',
        'kf.ywsk.cc': '慾望時空',
        'kf.aldsn.cc': '阿拉德少女',
        'kf.qysg.vip': '權慾三國',
        'kf.sgzj.vip': '三國戰姬',
        'localhost': '慾望時空',
      }
      if (host && urls[host]) gName = urls[host]
    }

    if (gName && gName != '未知') {
      let tt = t('kefu_center')
      document.title = '[' + gName + ']' + tt
      setName('[' + gName + ']')
    }
    setgName(gName)

  }

  const Loading = ({ t }) => {
    return <>
      <div style={{ position: "fixed", right: "0.3rem", bottom: "0.8rem", color: '#00b578' }}>
        <DotLoading color='currentColor' />
        <span>{t('connecting')}</span>
      </div>
    </>
  }

  const disabledName = (e) => {

  }

  useEffect(() => {
    
    let email = search.get('email')
    if (email) {
      console.log('eee', email)
      setMail(email?.replace(new RegExp('/', 'g'), ''))
    }
    getName()
  }, [])

  //旧客服 + plus18 UI設計客服頁面 juhe-tc:/opt/shiz-kefu-2
  return <div>
    <div style={{ padding: "0.3rem 0", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "6rem", boxSizing: "border-box" }}>
      <div>
        <div><img src={require('../../images/kefu.png')} style={{ width: "1.5rem" }} /></div>
        {/* <div style={{position:"relative", }}>
          <img src={require('../../images/01.png')} style={{ width: "0.55rem", position:"absolute", top:"-4px", left:"0.65rem" }} />
          <img src={require('../../images/kefu.png')} style={{ width: "1.5rem" }} />
        </div> */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "start", padding: "0.1rem 0.4rem", marginTop: "-0.5rem" }}>
          <div className='t-box'>{t('hello')}</div>
          <div className='t-box'>{t('welcome')}</div>
          <div className='t-box'>{isWidgetReady ? t('connected') : t('connecting')}</div>
          <div className='t-box'>{isWidgetReady ? t('click_to_chat') : t('waitting')}</div>
        </div>
      </div>
      <div style={{ color: "#B1B5C3", fontSize: "0.14rem", marginTop: "0.3rem", boxSizing: "border-box", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        {/* {mail && <div>
                  <div style={{marginBottom:"0.08rem"}}>{t('email')}</div>
                  <div>{mail}</div>
                </div>} */}
      </div>
    </div>
    {/* <img src={require('../../images/02.png')} style={{ width: "100%",position:"fixed", bottom:"1.5rem", left:"0" }} /> */}
    {/* logo */}
    <div style={{ display: "flex", fontSize: "0.2rem", color: "#FCFCFD", justifyContent: "end", position: "absolute", bottom: "0.2rem", left: "0.2rem", alignItems: "center" }}>
      <div><img src={require('../../images/logo.png')} style={{ width: "0.3rem", marginRight: "0.08rem" }} /></div>
      <div>Plus18 Games</div>
    </div>
    <>
      {lang == 'vi' && <LiveChatWidget license={"13848468"} visibility="minimized" customerName={gameName} group={2} />}
      {lang == 'en' && <LiveChatWidget license={"13848468"} visibility="minimized" customerName={gameName} group={1} />}
      {lang == 'hk' && <LiveChatWidget license={"13848468"} visibility="minimized" customerName={gameName} />}
      {isWidgetReady ? '' : <Loading t={t} />}
      {isWidgetReady && (
        <div className="chat-guide" aria-hidden="true">
          <svg className="chat-guide-finger" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
            <g transform="rotate(-35 32 32)">
              <path
                d="M28.5 8.5c0-2.2 1.8-4 4-4s4 1.8 4 4v18.2c1.1-.7 2.5-1.1 3.9-1.1 2.8 0 5.1 2.1 5.4 4.8l.2 1.8c1.3-.4 2.8-.4 4.1.2 2.5 1.1 3.8 3.9 3.1 6.5l-4.2 15.2c-1.3 4.6-5.5 7.8-10.3 7.8H28.2c-4.4 0-8.2-3.1-9.1-7.4l-2.6-12.1c-.7-3.2.7-6.5 3.5-8.1l3.5-2V8.5z"
                fill="#FFD27A"
                stroke="#E8A83A"
                strokeWidth="2"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        </div>
      )}
    </>
  </div>
  // //旧客服 + 新UI 104:/opt/shiz-kefu-2
  //   return (
  //     <div style={{ position: "fixed", left: 0, top: 0, right: 0, bottom: 0, }}>
  //       <div className="yindao yindaocontainer" style={{ width: "100%", height: "100%", overflow: "auto" }}>
  //         <div style={{ textAlign: "center", color: "#444", fontSize: "0.18rem", marginTop: "0.1rem", fontWeight: "bold" }}>客服專線</div>
  //         <div style={{ textAlign: "", paddingTop: "0.2rem", zIndex: 1, height:"100%" , background: "linear-gradient(90deg, #ef9b5f, #ea677c)", position:"relative"}}>
  //           <div><img src={(require("../../images/n.jpg"))} style={{ width: "100%", margin: 0 ,height:"80%"}} /></div>
  //           {mail ? <div style={{position:"absolute", top:"4.8rem", fontSize:"0.14rem", fontWeight:"bold", color:"#000", left:"0.1rem", lineHeight:"0.25rem", background:"#2878ff", borderRadius:"0.1rem", padding:"0.15rem", color:"#fff"}}>
  //             <div>點擊右側咨詢按鈕無法連接的<br/>請聯繫客服郵箱:</div>
  //             <div>{mail}</div>
  //           </div>:''}
  //         </div>
  //         {/* <div style={{position: "fixed", left : ""}}>
  //           <h4>歡迎來到客服中心</h4>
  //           <p>客服圖標在下方，點擊開始與在線客服聊天！</p>
  //         </div> */}
  //         {/* <div style={{  backgroundImage: `url(${require("../../images/bg.png")})`, width: "100%", height: "7rem", margin: 0, marginTop: "-0.04rem", zIndex: 2, justifyContent: "center" }}> */}
  //         {/* <div style={{ display: "flex",background: "linear-gradient(90deg, #ea677c, #ef9b5f)", backgroundImage: `url(${require("../../images/bg.png")})`, width: "100%", height: "3rem", margin: 0, marginTop: "-0.04rem", zIndex: 2, justifyContent: "center" }}> */}

  //         {/* </div> */}

  //         <>
  //           <LiveChatWidget license="13848468" visibility="minimized" customerName={gameName} />
  //           { isWidgetReady ? '': <Loading />}
  //         </>
  //       </div>
  //     </div>
  //   );




  //旧客服+旧UI   104：/opt/shiz-kefu
  // return (
  //   <div style={{ position: "fixed", left: 0, top: 0, right: 0, bottom: 0, }}>
  //     <div className="yindao yindaocontainer" style={{ width: "100%", height: "100%", overflow: "auto" }}>
  //       <div style={{ textAlign: "center", color: "#444", fontSize: "0.18rem", marginTop: "0.2rem", fontWeight: "bold" }}>{kfName}客服中心</div>
  //       <div style={{ display: "flex", background: "#0284f6", width: "100%", height: "1rem", marginTop: "0.2rem", }}></div>
  //       <div style={{ textAlign: "center", padding: 0, zIndex: 1 }}>
  //         <img src={(require("../../images/bg.jpg"))} style={{ width: "100%", margin: 0 }} />
  //       </div>
  //       <div style={{ display: "flex", backgroundImage: "linear-gradient(#0384f9,#fff)", width: "100%", height: "3rem", margin: 0, marginTop: "-0.04rem", zIndex: 2, justifyContent: "center" }}>
  //         <div style={{ width: "3rem", height: "3rem", background: "#fff", borderRadius: "0.05rem", boxShadow: "0 0 0.1rem #06C", marginTop: 0, textAlign: "left", padding: "0.2rem", boxSizing: "border-box" }}>
  //           <h4 style={{ textAlign: "center" }}>親愛的玩家，您好：</h4>
  //           <p style={{ fontSize: "0.14rem", textAlign: "left", textIndent: "0.2rem", padding: "0.1rem", lineHeight: "0.3rem" }}>  歡迎來到客服中心，客服正在接入中，請稍等。待右下方聊天圖標出現后，您可以點擊右下方的客服圖標，直接與在線客服聊天，祝您遊戲愉快！</p>
  //         </div>
  //       </div>

  //       <>
  //         <LiveChatWidget license="13848468" visibility="minimized" customerName={gameName} />
  //         { isWidgetReady ? '': <Loading />}
  //       </>
  //     </div>
  //   </div>
  // );



}

export default Home;